export const searchFormId = 'search_invite_targets';
